import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import usePrevious from 'lib/src/hooks/usePrevious';
import { getUserIsPosting, getUserPostSuccess, getUsersError } from '@selectors/users';
import { deleteUserApplication } from '@actions/users';
import { Submission } from 'src/types/shared/Assessments';

export default function useDeleteUserApplication(application: Submission): UseDeleteUserAppReturn {
    const dispatch = useDispatch();

    const handleSubmit = useCallback(() => {
        dispatch(deleteUserApplication(application));
    }, [dispatch, application]);

    const error = useSelector(getUsersError);
    const isPosting = useSelector(getUserIsPosting);
    const postSuccess = useSelector(getUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    return {
        handleSubmit,
        isPosting,
        error,
        prevSuccess,
        postSuccess,
    };
}

interface UseDeleteUserAppReturn {
    handleSubmit: () => void;
    isPosting: boolean;
    error: string | null;
    prevSuccess: boolean;
    postSuccess: boolean;
}
